import { resourcePath } from '@gameday/utils/resource-path';
import { getSafeLanguagePath } from './languageHelpers';
const formatCallSign = (str = '') => str.replace(/\W/g, '').toLowerCase();

export default ({ gamePk = '', callSign = '' }, gameContext, language = 'en') => {
    const params = {
        game_pk: gamePk,
        callSign: formatCallSign(callSign),
        languagePath: getSafeLanguagePath(language)
    };

    return resourcePath.get(`${gameContext}AudioLink`, params) || resourcePath.get('audioLink', params);
};
